import React, { useMemo } from 'react';
import StableMuiDialog from '../../../../common/StableMuiDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const EQWarningDialog = ({ open, onClose, rar, eq }) => {
  const percentageDifference = useMemo(() => {
    if (!rar || !eq || rar === 0) return null;
    return ((rar - eq) / rar) * 100;
  }, [rar, eq]);

  const formattedPercentage = useMemo(() => {
    if (percentageDifference === null) return null;
    return percentageDifference.toFixed(1);
  }, [percentageDifference]);

  if (!rar || !eq) return null;

  return (
    <StableMuiDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        The EQ rate is lower than RAR
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Typography variant="body1">
            <strong>RAR:</strong> {rar}
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span style={{ border: '1px solid #f0ad4e', padding: '2px 4px', borderRadius: '2px' }}>
              <strong>EQ:</strong> {eq}
            </span>
            {formattedPercentage !== null && (
              <span>({`-${formattedPercentage}%`})</span>
            )}
          </Typography>
        </Box>
        {formattedPercentage !== null && (
          <Typography variant="body2" sx={{ mb: 0 }}>
            This means that if you equalize using the EQ ratio instead of the RAR, all cases start with a {formattedPercentage}% reduction (beacause IFMV would be {formattedPercentage}% higher than it is when using the RAR). <strong className="underline">NOTE:</strong> All displayed IFMV's will still be calculated using the RAR, in the future we will have the ability to toggle which ratio we use in this system.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </StableMuiDialog>
  );
};

export default React.memo(EQWarningDialog);
